<template>
  <div class="gallery--category col-xs-12">
    <div class="filter--title" @click="window.width < 767 ? mobile() : ''">
      {{ translations.category }}
      <i class="fas fa-angle-down" ref="iconDown"></i>
    </div>
    <ul class="row category-container" ref="category">
      <li
        v-for="(category, i) in categories"
        :key="i"
        class="col-xs-12 col-md-3 col-sm-6"
      >
        <button
          :id="category.id.slice(5)"
          @click="filterCategory(category.id.slice(5), $event)"
        >
          <span
            v-if="category.id.includes('art22.07')"
            class="category category--red"
          ></span>
          <span
            v-else-if="category.id.includes('art22.08')"
            class="category category--yellow"
          ></span>
          <span>{{ category.label }}</span>
          <i ref="closeIcon" class="far fa-times"></i>
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="js">
import axios from "axios";

export default {

  name: 'GalleryCategory',
  props: ["translations", "config", "dataResult", "showElements"],
  data() {
    return {
      categories: {},
      activeCategories: {},
      list: {},
      window: {
        width: 0
      }
    };
  },
  created() {
    this.getCategory();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {

    getCategory() {
      axios
          .get(this.config.getCategory + '?language=' + this.config.language)
          .then(response => {
            this.categories = response.data;
          })
          .catch(function (error) {
            document.getElementById("gallery").innerHTML = error;
          });
    },
    filterCategory(categoryId) {
      let categoryButton = document.getElementById(categoryId);
      if (categoryButton.classList.contains('active')) {
        categoryButton.classList.remove('active');
        this.dataResult.categories = this.dataResult.categories.filter((e) => e !== categoryId);
        //if (this.dataResult.categories.length === 0) {
        //  this.dataResult.categories.push('');
       // } 
      } else {
        categoryButton.classList.add('active');
        this.dataResult.categories.push(categoryId);
      }

      this.refreshGalleryList();
    },
    refreshGalleryList() {
      const json = JSON.stringify(this.dataResult);
      const url = this.config.filter + '?language=' + this.config.language + '&size=' + this.showElements;
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      axios.post(url, json, config)
          .then(data => {
            this.list = data.data.gallerieSearchList;
            this.$emit('update-gallery', this.list, data.data.totalPages);
          })
          .catch(e => {
            console.log(e);
          });
    },
    handleResize() {
      this.window.width = window.innerWidth;
    },
    mobile() {
      this.$refs.category.classList.toggle('active');
      this.$refs.iconDown.classList.toggle('active');
    }
  }
};
</script>
